/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment,
  MenuItem
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { ValidateDepartment } from '../../assets/validation';
import ContentLoader from '../../utils/errorPages/ContentLoader';
import DeptAction from '../../store/actions/DepartmentAction';
import globalAction from '../../store/actions/GlobalAction';

function DepartmentView({ deptId, openmodal, onCloseModal }) {
  const dispatch = useDispatch();

  // Replace 'data' with your reducer name
  const { itemData, isLoading } = useSelector((state) => state.department);
  const { statusData } = useSelector((state) => state.global);

  useEffect(() => {
    dispatch(DeptAction.getItem(deptId));
    dispatch(globalAction.getClientStatus());
  }, [dispatch, deptId]);
  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      //   aria-labelledby="modal-modal-title"
      //   aria-describedby="modal-modal-description"
    >
      <Box>
        {isLoading ? <ContentLoader /> : ''}
        <Formik
          initialValues={{
            name: itemData && itemData.name ? itemData.name : '',
            status: itemData && itemData.status ? itemData.status : ''
          }}
          enableReinitialize
          validationSchema={ValidateDepartment}
          onSubmit={{}}
        >
          {({ values, handleChange, handleBlur, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="View Department"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="name"
                    fullWidth
                    label="Department Name"
                    name="name"
                    margin="normal"
                    disabled
                    placeholder="Enter Department Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-department" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    id="status"
                    fullWidth
                    label="Status"
                    name="status"
                    margin="normal"
                    select
                    disabled
                    value={values.status}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-arrow-down" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  >
                    {statusData &&
                      statusData.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.status}
                        </MenuItem>
                      ))}
                  </TextField>
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      onCloseModal();
                    }}
                  >
                    Close
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

DepartmentView.propTypes = {
  deptId: PropTypes.string.isRequired,
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default DepartmentView;
